gsap.registerPlugin(ScrollTrigger, SplitText);

// Home page - Video Banner
gsap.to(".video-banner-animation", { opacity:1 })
const video_banner = new SplitText(".video-banner-animation", {type:"lines", linesClass:"lines"})

gsap.to(".video-banner-animation", {autoAlpha:1})
video_banner.lines.forEach((line) => {
    let chars = new SplitText(line, {type:"lines"})
    gsap.from(chars.lines, { yPercent:100, duration:1 })
});


// Home page - Our Program
gsap.timeline()
    .fromTo(".program-card", { yPercent: 100, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 1.25 })
    .to(".program-card-animation", { opacity:1 });
const program_card = new SplitText(".program-card-animation", {type:"lines", linesClass:"lines"})

gsap.to(".program-card-animation", {autoAlpha:1})
program_card.lines.forEach((line) => {
    let chars = new SplitText(line, {type:"lines"})
    gsap.from(chars.lines, { yPercent:100, delay: 1.25 })
});


// Home page - Image With Text
const img_with_text = new SplitText(".img_with_text_heading", {type:"lines", linesClass:"lines"})

gsap.to(".img_with_text_heading", {autoAlpha:1})
img_with_text.lines.forEach((line) => {
    let chars = new SplitText(line, {type:"lines"})
    gsap.from(chars.lines, {yPercent:100, duration: 1,
        scrollTrigger: {
            trigger: ".img_with_text_content",
            start: "top 70%",
            end: "top 70%",
            toggleActions: "play none reverse reverse"
        }
    })
});

gsap.from(".img_with_text_img img", {yPercent:-100, duration: 1,
    scrollTrigger: {
        trigger: ".img_with_text_img",
        start: "top 65%",
        end: "top 65%",
        toggleActions: "play none reverse reverse",
        // markers: true,
    }
});


// Home Page - Review Slider
gsap.from(".review-slider-img .modal-image-wrap", {yPercent:-110, duration: 1,
    scrollTrigger: {
        trigger: ".review-section",
        start: "top 65%",
        end: "top 65%",
        toggleActions: "play none reverse reverse"
    }
});


// Home page - Our Author
const learning_slider = new SplitText(".author-animation", {type:"lines", linesClass:"lines"})

gsap.to(".author-animation", {autoAlpha:1})
learning_slider.lines.forEach((line) => {
    let chars = new SplitText(line, {type:"lines"})
    gsap.from(chars.lines, { yPercent:100, duration:1,
        scrollTrigger: {
            trigger: ".our-author",
            start: "top 65%",
            end: "top 65%",
            toggleActions: "play none reverse reverse",
            // markers: true,
        } 
     })
});

gsap.from(".author-list-thumb", { yPercent: 30, opacity:0, duration: 1.5,
    scrollTrigger: {
        trigger: ".our-author",
        start: "top 65%",
        end: "top 65%",
        // markers: true,
        toggleActions: "play none reverse reverse"
    }
});

gsap.from(".author-main .video-wrapper", { xPercent: -40, opacity:0, duration: 1.5,
    scrollTrigger: {
        trigger: ".our-author",
        start: "top 65%",
        end: "top 65%",
        // markers: true,
        toggleActions: "play none reverse reverse"
    }
});

gsap.from(".author-main .text-wrapper", { xPercent: 40, opacity:0, duration: 1.5,
    scrollTrigger: {
        trigger: ".our-author",
        start: "top 65%",
        end: "top 65%",
        // markers: true,
        toggleActions: "play none reverse reverse"
    }
});

gsap.from(".author-list-thumb+.btn", { yPercent: 100, opacity:0, duration: 1.5,
    scrollTrigger: {
        trigger: ".our-author",
        start: "top 65%",
        end: "top 65%",
        // markers: true,
        toggleActions: "play none reverse reverse"
    }
});


// Home page - We climb slider

gsap.from(".gallery-thumbs", { xPercent:50, opacity:0, duration: 1.5,
    scrollTrigger: {
        trigger: ".learning-bundle",
        start: "top 65%",
        end: "top 65%",
        // markers: true,
        toggleActions: "play none reverse reverse"
    }
});

gsap.from(".gallery-slider", { xPercent:-50, opacity:0, duration: 1.5,
    scrollTrigger: {
        trigger: ".learning-bundle",
        start: "top 65%",
        end: "top 65%",
        // markers: true,
        toggleActions: "play none reverse reverse"
    }
});


// Home Page -  Blog Post Grid   blog-post-grid
const blog_post_grid = new SplitText(".blog-post-animation", {type:"lines", linesClass:"lines"})

gsap.to(".blog-post-animation", {autoAlpha:1})
blog_post_grid.lines.forEach((line) => {
    let chars = new SplitText(line, {type:"lines"})
    gsap.from(chars.lines, { yPercent:110, duration:1,
        scrollTrigger: {
            trigger: ".blog-post-grid-parent",
            start: "top 75%",
            end: "top 75%",
            // markers: true,
            toggleActions: "play none reverse reverse"
        } 
     })
});

gsap.from(".blog-post-grid", { yPercent:110, duration:1,
    scrollTrigger: {
        trigger: ".blog-post-grid-parent",
        start: "top 75%",
        end: "top 75%",
        toggleActions: "play none reverse reverse",
        ease: "linear"
    }
})


// Home page - Image Banner
gsap.to(".image-banner-animation", { opacity:1 })
const image_banner = new SplitText(".image-banner-animation", {type:"lines", linesClass:"lines"})

gsap.to(".image-banner-animation", {autoAlpha:1})
image_banner.lines.forEach((line) => {
    let chars = new SplitText(line, {type:"lines"})
    gsap.from(chars.lines, { yPercent:100, duration:1,
        scrollTrigger: {
            trigger: ".banner-section-style-2",
            start: "top 70%",
            end: "top 70%",
            toggleActions: "play none reverse reverse"
        } 
    })
});